import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import axios from 'helpers/axios/axios';
import config from 'Config';
import { useSessionContext } from '../../contexts/sessionProvider/SessionProvider';

type UseExistingUserCheckType = {
  isLoading: boolean;
  isNewUser: boolean;
  isError: boolean;
  isEmailChecked: boolean;
  identityId: string;
  checkedEmail: string;
}

export const useExistingUserCheck = (email: string): UseExistingUserCheckType => {
  const [isEmailChecked, setIsEmailChecked] = useState(false);
  const { setIsNewUser } = useSessionContext();
  const {
    isLoading, data, isError
  } = useQuery(
    ['existingUser', email],
    () => axios.get(`${config.API_EXISTING_USER_CHECK}`, { params: { email } }),
    { enabled: !!email, retry: false, staleTime: 1000 * 60 * 5 }
  );

  const isNewUser = !data?.data.guid;
  useEffect(() => {
    if (data) {
      setIsEmailChecked(true);
      setIsNewUser(isNewUser);
    }
  }, [data]);

  return {
    isLoading,
    isNewUser,
    isError,
    isEmailChecked,
    identityId: String(data?.data?.guid?.toString().toLowerCase() ?? ''),
    checkedEmail: email
  };
};
